module.exports = __webpack_public_path__ + "img/13-map-c@2x.a012e47f.png";